function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var GameTableTemplate = require('../../lib/templates/table-gametemplate');
var GameBoard = require('./lib/ui/game-board/game-board');
var Pot = require('./lib/ui/pot/pot');
var JSON = require('json-bigint');
var PokerStats = require('./lib/stats');
var htmlTemplate = require('./lib/game-html.template');
var PokerGameRulesTemplate = require('./lib/poker-game-rules.template');
var PokerGameOptionsTemplate = require('./lib/poker-game-options.template');
var PokerState = require('./lib/poker-state.js');
var PokerStake = require('./lib/poker-stake.js');
var PokerQueue = require('./lib/poker-queue.js');
var PokerUI = require('./lib/poker-ui.js');
var PokerCards = require('./lib/poker-cards.js');
var AppSettings = require('./lib/poker-settings');

//////////////////
// CONSTRUCTOR  //
//////////////////
var Poker = /*#__PURE__*/function (_GameTableTemplate) {
  function Poker(app) {
    var _this;
    _classCallCheck(this, Poker);
    _this = _callSuper(this, Poker, [app]);
    _this.app = app;
    _this.name = 'Poker';
    _this.slug = 'poker';
    _this.title = 'Saito Poker';
    _this.description = "Texas Hold'em Poker for the Saito Arcade. With five cards on the table and two in your hand, can you bet and bluff your way to victory? \n\t\t\t\t<br> Play with up to five other players for fun or wager integrated web3 cryptocurrencies through your handy Saito Wallets";
    _this.categories = 'Games Cardgame Casino';
    _this.card_img_dir = '/saito/img/arcade/cards';
    _this.card_img = 'new_red';
    _this.felt = 'green';
    _this.theme = 'threed';
    _this.icon = 'fa-solid fa-diamond';
    _this.minPlayers = 2;
    _this.maxPlayers = 6;
    _this.stats = new PokerStats(app, _this);
    _this.board = new GameBoard(app, _this);
    _this.pot = new Pot(app, _this);

    /********************
    *********************
    *********************
    ***
    *** CRYPTO *NEEDS* to be in a string, but the internal math/logic of the game is a lot less bug-ridden
    *** if we _secretly_ make all games use 100 chip buy ins, with all bets as whole numbers of chips... 
    *** so everything -- the blind, the pot, the debt, the credit is a whole number... 
    *** If there is a stake, such as 32 TRX or 0.005 BTC, we divide that by 100, and multiply by the whole numbers
    *** when rendering UI or initiating transfers.
    *** Stake 250.67 SAITO --> x = 2.5067 SAITO. Bets are in increments of 2.5067 SAITO, e.g. 1x, 2x, 3x ...  
    ***
    ***
    this.game.crypto;       // (STRING) TICKER of crypto or "CHIPS" in standard game
    this.game.stake;        // (STRING) TOTAL crypto buy-in OR 100 (if chips)
    this.game.chips;        // (INTEGER) TOTAL CHIPS per buy-in,
    this.game.blind_mode;     // (STRING) "static" or "increase"
     
     
    this.game.state.round;    // (INT) round in game
    this.game.state.big_blind;    // (INTEGER) value of big-blind
    this.game.state.small_blind;  // (INTEGER) value of small-blind
    this.game.state.last_raise;   // (INTEGER) value of last raise
    this.game.state.required_pot; // (INTEGER) value players need in pot to keep playing
     
    this.game.state.passed[i];    // (INT) 1 = has passed
    this.game.state.player_pot[i];  // (INTEGER) value contributed to pot
    this.game.state.debt[i];    // (INTEGER) amount due
    this.game.state.player_credit[i]; // (INTEGER) bankroll
    *********************
    *********************
    ********************/

    _this.updateHTML = '';
    _this.sort_priority = 1;
    return _this;
  }
  _inherits(Poker, _GameTableTemplate);
  return _createClass(Poker, [{
    key: "initializeGame",
    value: function initializeGame() {
      var _this$game;
      //
      // test crypto hand scoring
      //
      // this is just convenience code for checking why two hands
      // might not score properly. please leave this in for now.
      //
      //let hand1 = ["S8","S7","H3","H5","C2","S6","H4"];
      //let hand2 = ["C10","D2","H3","H5","C2","S6","H4"];
      //console.log("TESTING HAND SCORING");
      //let score1 = this.scoreHand(hand1);
      //let score2 = this.scoreHand(hand2);
      //let winner = this.pickWinner(score1, score2);
      //console.log("score1: " + JSON.stringify(score1));
      //console.log("score2: " + JSON.stringify(score2));
      //console.log("winner: " + JSON.stringify(winner));

      _superPropGet(Poker, "initializeGame", this, 3)([]);

      //
      // CHIPS or CRYPTO ?
      //
      this.settleNow = false;
      this.settle_every_hand = false;
      if (this.game.player == 0) {
        if (!this.game.pool[0]) {
          this.addPool();
        }
      }

      //
      // initialize game state
      //
      if (!((_this$game = this.game) !== null && _this$game !== void 0 && _this$game.state)) {
        this.game.state = this.returnState(this.game.players.length);
        this.initializeGameStake(this.game.crypto, this.game.stake);
        this.game.stats = this.returnStats();
        this.startRound(); // DOM update on new round
      }

      //
      // browsers display UI
      //
      if (this.browser_active) {
        this.board.render();
      }
    }
  }, {
    key: "returnShortGameOptionsArray",
    value: function returnShortGameOptionsArray(options) {
      var sgoa = _superPropGet(Poker, "returnShortGameOptionsArray", this, 3)([options]);
      var ngoa = {};
      var crypto = '';
      for (var i in sgoa) {
        if (sgoa[i] != '') {
          var okey = i;
          var oval = sgoa[i];
          var output_me = 1;
          if (okey == 'chip') {
            if (oval !== '0') {
              okey = 'small blind';
            } else {
              output_me = 0;
            }
          }
          if (okey == 'blind_mode') {
            if (oval == 'increase') {
              okey = 'mode';
              oval = 'tournament';
            } else {
              output_me = 0;
            }
          }
          if (okey == 'num_chips') {
            okey = 'chips';
          }
          if (okey == 'eliminated') {
            var str = '';
            for (var key in oval) {
              str += this.app.keychain.returnUsername(key) + ', ';
            }
            oval = str;
          }
          if (output_me == 1) {
            ngoa[okey] = oval;
          }
        }
      }
      return ngoa;
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this$game2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.browser_active) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!this.initialize_game_run) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _context.n = 3;
              return this.injectGameHTML(htmlTemplate());
            case 3:
              //
              // ADD MENU
              //
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addSubMenuOption('game-game', {
                text: 'How to Play',
                id: 'game-rules',
                "class": 'game-rules',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.show(game_mod.returnGameRulesHTML());
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Stats',
                id: 'game-stats',
                "class": 'game-stats',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.stats.toggle();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Settings',
                id: 'game-settings',
                "class": 'game-settings',
                callback: function callback(app, game_mod) {
                  game_mod.loadSettings();
                }
              });

              //default by device
              this.theme = this.app.browser.isMobileBrowser() ? 'flat' : 'threed';
              if (this.loadGamePreference('poker-theme')) {
                this.theme = this.loadGamePreference('poker-theme');
              }
              if (this.loadGamePreference('poker-cards')) {
                this.card_img = this.loadGamePreference('poker-cards');
              }
              if (this.loadGamePreference('poker-felt')) {
                this.felt = this.loadGamePreference('poker-felt');
              }
              this.cardfan.container = '.mystuff';
              _context.n = 4;
              return _superPropGet(Poker, "render", this, 3)([app]);
            case 4:
              this.board.render();
              this.playerbox.mode = 2;
              this.refreshPlayerboxes();
              this.menu.addChatMenu();
              this.menu.render();
              this.log.render();
              this.displayButton();
              this.insertCryptoLogo((_this$game2 = this.game) === null || _this$game2 === void 0 || (_this$game2 = _this$game2.options) === null || _this$game2 === void 0 ? void 0 : _this$game2.crypto);

              //
              // gametabletemplate adds a scoreboard DIV that shows HIDE / LEAVE / JOIN instructions
              // which we are going to hide to prevent UI / UX clutter, but leave functional so as to
              // enable faster experimentation.
              //
              if (document.querySelector('.game-scoreboard')) {
                document.querySelector('.game-scoreboard').style.display = 'none';
              }
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "receiveStopGameTransaction",
    value: function () {
      var _receiveStopGameTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resigning_player, txmsg) {
        var loser, i, _this$game3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              console.log('Poker: receiveStopGameTransaction', txmsg, resigning_player);
              if (!(this.publicKey === resigning_player)) {
                _context2.n = 1;
                break;
              }
              _superPropGet(Poker, "receiveStopGameTransaction", this, 3)([resigning_player, txmsg]);
              return _context2.a(2);
            case 1:
              loser = -1;
              i = 0;
            case 2:
              if (!(i < this.game.players.length)) {
                _context2.n = 4;
                break;
              }
              if (!(this.game.players[i] == resigning_player)) {
                _context2.n = 3;
                break;
              }
              loser = i + 1;
              return _context2.a(3, 4);
            case 3:
              i++;
              _context2.n = 2;
              break;
            case 4:
              if (!(loser < 0)) {
                _context2.n = 5;
                break;
              }
              console.log('Player is not in the game');
              return _context2.a(2);
            case 5:
              if (txmsg !== null && txmsg !== void 0 && txmsg.deck) {
                if (!((_this$game3 = this.game) !== null && _this$game3 !== void 0 && _this$game3.opponent_decks)) {
                  this.game.opponent_decks = {};
                }
                if (!this.game.opponent_decks["".concat(loser)]) {
                  this.game.opponent_decks["".concat(loser)] = txmsg.deck;
                }
              }
              this.displayPlayerNotice("<div class=\"plog-update\">left the table</div>", loser);
              this.playerbox.addClass('folded', loser);
              this.updateLog(this.game.state.player_names[loser - 1] + ' left the table');
              if (!this.game.state.passed[loser - 1]) {
                this.game.stats[resigning_player].folds++;
                this.game.state.passed[loser - 1] = 1;
                this.game.state.last_fold = loser;
              }
              _context2.n = 6;
              return _superPropGet(Poker, "receiveStopGameTransaction", this, 3)([resigning_player, txmsg]);
            case 6:
              if (this.game.target == loser) {
                this.game.state.plays_since_last_raise--;
                this.startQueue();
              }
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function receiveStopGameTransaction(_x2, _x3) {
        return _receiveStopGameTransaction.apply(this, arguments);
      }
      return receiveStopGameTransaction;
    }()
  }, {
    key: "endTurn",
    value: function endTurn() {
      var nextTarget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.browser_active) {
        this.updateStatus('submitting move to peers...');
        $('.option').off();
      }
      if (this.shot_clock) {
        clearTimeout(this.shot_clock);
        this.shot_clock = null;
      }
      this.game_help.hide();
      _superPropGet(Poker, "endTurn", this, 3)([nextTarget]);
    }
  }, {
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return PokerGameRulesTemplate(this.app, this);
    }
  }, {
    key: "returnAdvancedOptions",
    value: function returnAdvancedOptions() {
      return PokerGameOptionsTemplate(this.app, this);
    }

    // Extension of game engine stub for advanced stake selection before starting a game
  }, {
    key: "attachAdvancedOptionsEventListeners",
    value: function attachAdvancedOptionsEventListeners() {
      var blindModeInput = document.getElementById('blind_mode');
      var numChips = document.getElementById('num_chips');
      var blindDisplay = document.getElementById('blind_explainer');
      var crypto = document.getElementById('crypto');
      var stakeValue = document.getElementById('stake');
      var chipInput = document.getElementById('chip_wrapper');
      //let stake = document.getElementById("stake");

      var updateChips = function updateChips() {
        if (numChips && stakeValue && chipInput /*&& stake*/) {
          if (crypto.value == '') {
            chipInput.style.display = 'none';
            stake.value = '0';
          } else {
            var nChips = parseInt(numChips.value);
            var stakeAmt = parseFloat(stakeValue.value);
            var jsMath = stakeAmt / nChips;
            chipInput.style.display = 'block';
          }
        }
      };
      if (blindModeInput && blindDisplay) {
        blindModeInput.onchange = function () {
          if (blindModeInput.value == 'static') {
            blindDisplay.textContent = 'Small blind is one chip, big blind is two chips throughout the game';
          } else {
            blindDisplay.textContent = 'Small blind starts at one chip, and increments by 1 every 5 rounds';
          }
        };
      }
      if (crypto) {
        crypto.onchange = updateChips;
      }
      if (numChips) {
        numChips.onchange = updateChips;
      }
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!container) {
        this.overlay.show("<div class=\"module-settings-overlay\"><h2>".concat(this.returnName(), " Settings</h2></div>"));
        container = '.module-settings-overlay';
        this.overlay.setBackgroundColor('#0001');
      }
      var as = new AppSettings(this.app, this, container);
      as.render();
    }
  }]);
}(GameTableTemplate);
Poker.importFunctions(PokerState, PokerStake, PokerQueue, PokerUI, PokerCards);
module.exports = Poker;